import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProjectList } from "../../Redux/Actions/projectActions";
import { columnsProjectsAdmin } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import TableComponentsCp from "../../Global Functions/tableComponentsCp";

const ListProjectsAdmin = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const { projects, loading } = useSelector((state) => state.projects);
  const { enumsData } = useSelector((state) => state.enumsData);

  const fetchDetails = useCallback(async (page, limit, status, showLoader = true) => {
    try {
      const projectData = {
        page,
        limit,
        status: Object.values(enumsData?.data?.ProjectStatus || {}),
        is_deleted: false,
        added_by: "admin",
        filter: debouncedSearch,
        ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
        ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
      };

      await dispatch(getProjectList(projectData, showLoader));

      if (!showLoader) {
        toast.success("Projects list refreshed");
      }
    } catch {
      if (!showLoader) {
        toast.error("Failed to refresh projects list");
      }
    }
  },
    [enumsData?.data?.ProjectStatus, debouncedSearch, dateRange.start, dateRange.end, dispatch]
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchDetails(pagination.current, pagination.pageSize);
    }, 150);
    return () => clearTimeout(timer);
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    if (projects?.total) {
      setPagination((prevData) => ({ ...prevData, total: projects.total }));
    }
  }, [projects]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  // const columns = React.useMemo(() => {
  //   return columnsProjectsAdmin(pagination.current, pagination.pageSize);
  // }, [pagination.current, pagination.pageSize]);


  return (
    <>
      <TableComponentsCp
        h3heading="Projects List"
        setState={setSearchQuery}
        pagination={pagination}
        // navigateTo="/enquiry/list"
        // buttonhead="View Enquiries"
        onChange={handleTableChange}
        columns={columnsProjectsAdmin}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        dataSource={(Array.isArray(projects?.data) && projects.data) || []}
        buttonhead="Add Project"
        navigateTo="/manage_projects/add"
        loading={loading}
      />

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListProjectsAdmin;
